import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

type LinkProps = {
    to: string;
    subtle?: boolean;
    external?: boolean;
    className?: string;
    children: React.ReactNode;
};

const Link: React.FC<LinkProps> = ({
    to,
    subtle = false,
    external = false,
    className = "",
    children,
}) => {
    const baseStyle = subtle
        ? "text-gray-500 hover:text-gray-700"
        : "text-red-600 hover:text-red-700";

    const combinedClassName = `${baseStyle} ${className}`.trim();

    if (external) {
        return (
            <a href={to} target="_blank" rel="noopener noreferrer" className={combinedClassName}>
                {children}
            </a>
        );
    }

    return <RouterLink to={to} className={combinedClassName}>{children}</RouterLink>;
};

export default Link;
